module.exports = __webpack_public_path__ + "img/va.0352452.svg";